fx.translations("de", {
    "Ajouter 2 pages" : "2 Seiten hinzufügen",
    "Supprimer 2 pages" : "2 Seiten löschen",
    "Votre album ne peut contenir moins de $ pages" : "Das Album kann nicht weniger als $ Seiten enthalten",
    "Copier" : "Kopieren",
    "Couper" : "Schneiden",
    
    "Nombre de photos par page" : "Anzahl der Fotos pro Seite",
    
    "Tout sélectionner" : "Alles auswählen",
    "Tout déselectionner" : "Alles abwählen",
    
    "Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème." : "Wenn nach dem Klicken auf die Anmeldeschaltfläche nichts passiert, bedeutet dies, dass Ihr Browser Pop-ups blockiert. Sie müssen einfach Ihrem Browser erlauben, Pop-ups anzuzeigen, um das Problem zu beheben.",
    "Nous avons bientôt fini de récupérer vos photos" : "Wir haben bald alle Ihre Fotos abgerufen",
    "On s’occupe de vous rediriger quand c’est terminé" : "Wir leiten Sie um, sobald es fertig ist",
   
    "Cliquez pour aller à la page" : "Klicken Sie, um zur Seite zu gehen",
    
    "Souhaitez-vous commander votre ouvrage dans l'état ?" : "Möchten Sie Ihr Werk so bestellen, wie es ist?",
  
    "La couverture a été changée" : "Der Umschlag wurde geändert",
    "Vérifier que tout est placé correctement sur votre couverture." : "Prüfen Sie, ob alles richtig auf Ihrem Umschlag platziert ist",
    
    "Ce changement de couverture n'est pas possible" : "Diese Umschlagänderung ist nicht möglich",
    "mais avec cette couverture votre album ne peut contenir <strong>plus de $ pages</strong>.<br><br> Veuillez supprimer des pages avant de choisir cette couverture." : "aber mit diesem Umschlag kann Ihr Album nicht <strong>mehr als $ Seiten</strong> enthalten.<br><br> Bitte löschen Sie Seiten, bevor Sie diesen Umschlag wählen.",
    "mais avec cette couverture votre album doit contenir <strong>au moins $ pages</strong>.<br><br> Veuillez ajouter des pages avant de choisir cette couverture." : "aber mit diesem Umschlag muss Ihr Album <strong>mindestens $ Seiten</strong> enthalten.<br><br> Bitte fügen Sie Seiten hinzu, bevor Sie diesen Umschlag wählen.",
    "J'ajoutes vos photos dans votre gallerie" : "Ich füge Ihre Fotos in Ihre Galerie ein",
    "Souhaitez-vous que je crée votre album photo ?" : "Möchten Sie, dass ich Ihr Fotoalbum erstelle?",
    "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Ihre Fotos werden chronologisch angeordnet,<br>und Sie müssen nur noch Ihr Album überprüfen.",
    "Attention : votre contenu sera totalement remplacé." : "Achtung: Ihr Inhalt wird vollständig ersetzt.",
    "Oui, Créez mon album" : "Ja, los geht's",
    "Non, merci" : "Nein, danke",
    "Un instant, je place vos photos..." : "Einen Moment, ich platziere Ihre Fotos...",
    "Cet aperçu vous montre comment sera votre album une fois imprimé.<br/>Assurez-vous de n'avoir rien oublié avant de commander." : "Diese Vorschau zeigt Ihnen, wie Ihr Album nach dem Druck aussehen wird.<br/>Stellen Sie sicher, dass Sie nichts vergessen haben, bevor Sie bestellen.",
    "L'aperçu de votre album est prêt !" : "Die Vorschau Ihres Albums ist fertig!",
    "Assurez-vous de n'avoir rien oublié avant de commander." : "Stellen Sie sicher, dass Sie nichts vergessen haben, bevor Sie bestellen.",
    "Vérifier mon album" : "Mein Album prüfen",
    "J'ai préparé l'aperçu de votre album" : "Ich habe die Vorschau Ihres Albums vorbereitet",
    "Voir l'aperçu" : "Vorschau anzeigen",
    
    "Continuer" : "Fortsetzen",

    "Copie en cours" : "Kopieren läuft",
    "Ca va être rapide !" : "Es wird schnell gehen!",
    
    "Choisissez la finition de votre album" : "Wählen Sie die Ausführung Ihres Albums",
    "Quel type d'ouverture souhaitez-vous ?" : "Welche Art von Öffnung wünschen Sie?",
    
    "Choisissez la forme de votre album" : "Wählen Sie die Form Ihres Albums",
   
    "Grille activée" : "Raster aktiviert",
    "Grille désactivée" : "Raster deaktiviert",
    "Epaisseur" : "Dicke",

    "Vue Globale" : "Gesamtansicht",
    "Vue Edition" : "Bearbeitungsansicht",

    "Editer" : "Bearbeiten",
    "Prévisualiser" : "Vorschau",

    "Aller directement à l'éditeur" : "Direkt zum Editor gehen",
    "$ photos sélectionnées" : "$ Fotos ausgewählt",
    "Suivant" : "Weiter",
     
    "Sélectionner les meilleures !" : "Wählen Sie die besten aus!",
    "Tout sélectionner" : "Alles auswählen",
    "J'ai sélectionné vos photos" : "Ich habe Ihre Fotos ausgewählt",
    "Vous pouvez modifier ma sélection avant de lancer la création intelligente de votre album" : "Sie können meine Auswahl ändern, bevor Sie mit der intelligenten Erstellung Ihres Albums beginnen",
    "Créer votre album !" : "Erstellen Sie Ihr Album!",
     
    "Votre fichier a été importé" : "Ihre Datei wurde importiert",
    "Il a été ajouté à vos photos" : "Sie wurde Ihren Fotos hinzugefügt",

    "Options" : "Optionen",

    "+ $ €" : "+ $ €",

    "Couvertures" : "Umschläge",
    "Thèmes" : "Themen",
     
    "Mises en page" : "Layouts",
     
    "Vue Simple" : "Einfache Ansicht",
    "Changer la couverture" : "Umschlag wechseln",
     
    "Sauvegarder en tant que Modèle" : "Dieses Layout speichern",

    "Numéroter les pages" : "Seiten nummerieren",
    "Supprimer la numérotation" : "Nummerierung entfernen",
     
    "J'ai numéroté vos pages" : "Ich habe Ihre Seiten nummeriert",
    "Cliquez pour éditer la taille, la police et la couleur" : "Klicken Sie, um Größe, Schriftart und Farbe zu bearbeiten",
    "Ok" : "Ok",

    "Changer de modèle" : "Modell wechseln",

    "Choisissez la finition de votre album" : "Wählen Sie die Ausführung Ihres Albums",

    "Thématique" : "Empfohlen",
    "Classique" : "Klassisch",
    "Sauvegardé" : "Persönlich",

    "Nombre de photos" : "Anzahl der Fotos",

    "Placer vos photos automatiquement" : "Fotos automatisch platzieren",
    "Mises en pages" : "Layouts",

    // album preview (desktop.common.preview.BookTable)
    "Dos" : "Rückseite",
    "Votre album" : "Ihr Album",
    "Retour à l'éditeur" : "Zurück zum Editor",
    "Vue de face" : "Draufsicht",
    "Vue perspective" : "Perspektive",
    "Page précédente" : "Vorherige Seite",
    "Page suivante" : "Nächste Seite",
    "Pagination" : "Seitennavigation",
    "Vue" : "Ansicht",
    "Aperçu de votre album" : "Vorschau Ihres Albums",
});
